export const STATE_VEHICLE = {
    NEW: 'stateNew',
    USED: 'stateUsed',
    SERTIFICATED: 'stateSertificate',
    ACCIDENT: 'stateCrash',
};

export const STEERING_SIDE = {
    LEFT: 'steeringLeft',
    RIGHT: 'steeringRight',
};

export const STEERING_SIDE_OPTIONS = [
    { name: STEERING_SIDE.LEFT },
    { name: STEERING_SIDE.RIGHT },
];

export const ADVERT_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};

export const advertStatus = Object.values(ADVERT_STATUS);

export const VEHICLE_TYPES = {
    CAR_TYPE: 'Легковые',
    CAR: 'car',
    BIKE: 'bike',
    COMMERCIAL: 'commercial',
    BUS: 'Buses',
    TRAILER: 'Trailers',
};

export const PARTS_TYPES = {
    ACCESSORY: 'partsAccessory',
    BRAKES: 'brakes',
    CARBODY: 'partsCarbody',
    ELECTRIC: 'partsElectric',
    ENGINE: 'engine',
    EQUIPMENT: 'equipment',
    GAS_EQUIPMENT: 'partsGasEquipment',
    HEATING: 'partsHeating',
    INTERIOR: 'interior',
    MAINTENANCE: 'partsMaintenance',
    SUSPENSION: 'suspension',
    TRANSMISSION: 'transmission',
    WHEELS_PARTS: 'partsWheels',
    DISKS: 'disks',
    TYRE: 'tyres',
    WHEELS: 'wheels',
    CAPS: 'caps',
};

export const SERVICES_TYPES = {
    AUTOSCHOOL: 'autoschool',
    AUTOSERVICE: 'autoservice',
    BOX: 'box',
    GARAGE: 'garage',
    PAINTING: 'painting',
    CARWASH: 'carwash',
    TYRESERVICE: 'tyreservice',
    TOWTRUCK: 'towtruck',
    DISASSEMBLY: 'disassembly',
};

export const STATE_TYPES = {
    IDEAL: 'ideal',
    GOOD: 'good',
    NORMAL: 'normal',
    BAD: 'bad',
    SOBAD: 'needMoney',
};

export const SELL = 'sale';
export const RENT = 'rent';

export const ACCOUNT_TYPES = {
    USER: 'user',
    DEALER: 'dealer',
    CORPORATE: 'corporate',
};

export const CORPORATE_TYPES = {
    AUTOCOMPANY: 'autocompany',
    RENTCOMPANY: 'rentcompany',
    DEALER: 'dealer',
    PARTSCOMPANY: 'partscompany',
    AUTOEXPERT: 'autoexpert',
    INSURANCE: 'insurance',
    SERVICES: 'titleServices',
};

export const SERVICE_NAMES = {
    COMPANY: 'company',
    SERVICE: 'service',
    PARTS: 'parts',
    PLACEMENT: 'placement',
    RENT: 'rent',
    SELL: 'sell',
    ACTIVE_SERVICES: 'activeServices',
};

export const VEHICLE_FIELD_NAMES = {
    TYPE_VEHICLE: 'typeVehicle',
    TYPE: 'type',
    MARK: 'mark',
    MODEL: 'model',
    BODYTYPE: 'bodyType',
    GENERATION: 'generation',
    MODIFICATION: 'modification',
    ENGINE_VOLUME: 'engineVolume',
    POWER: 'power',
    ENGINE: 'engine',
    GBO: 'gbo',
    TRANSMISSION: 'transmission',
    DRIVEUNIT: 'driveunit',
};
